/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
// components/ManageSam/RevenueBreakdown/RevenueChart.jsx
import React from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js'
import { Bar } from 'react-chartjs-2'
import { format, parse } from 'date-fns'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
)

const RevenueChart = ({ monthlyRevenue }) => {
  if (!monthlyRevenue || monthlyRevenue.length === 0) {
    return (
      <div className="text-center py-12 text-gray-500">
        No revenue data yet
      </div>
    )
  }

  const labels = monthlyRevenue.map(item => {
    const date = parse(item.month, 'yyyy-MM', new Date())
    return format(date, 'MMMM')
  })
  const buildData = monthlyRevenue.map(item => Number(item.buildRevenue))
  const aiUsageData = monthlyRevenue.map(item => Number(item.aiUsageRevenue))

  const dataBar = {
    labels,
    datasets: [
      {
        label: 'Build',
        backgroundColor: '#4755e5',
        barPercentage: 0.5,
        barThickness: 20,
        borderRadius: 0,
        data: buildData,
        grouped: true,
        categoryPercentage: 1.0
      },
      {
        label: 'AI USAGE',
        backgroundColor: '#fd832a',
        barPercentage: 0.5,
        barThickness: 20,
        borderRadius: 0,
        data: aiUsageData,
        grouped: true,
        categoryPercentage: 1.0
      }
    ]
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        stacked: true,
        grid: {
          display: false
        }
      },
      y: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          callback: (value) => {
            return '$' + value.toFixed(0)
          }
        }
      }
    },
    plugins: {
      legend: {
        display: true,
        position: 'top',
        align: 'start',
        labels: {
          usePointStyle: true,
          boxWidth: 10,
          boxHeight: 10,
          padding: 20
        }
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            let label = context.dataset.label || ''
            if (label) {
              label += ': '
            }
            if (context.parsed.y !== null) {
              label += '$' + context.parsed.y.toFixed(2)
            }
            return label
          },
          footer: (tooltipItems) => {
            let total = 0
            tooltipItems.forEach((tooltipItem) => {
              total += tooltipItem.parsed.y
            })
            return 'Total: $' + total.toFixed(2)
          }
        }
      }
    }
  }

  return (
    <div style={{ height: '300px' }}>
      <Bar data={dataBar} options={options} />
    </div>
  )
}

export default RevenueChart
